import React from 'react';
import { useTranslation } from 'react-i18next'; // Add this import
import './Card.css';
import { useNavigate } from 'react-router-dom';

export const Card = ({
  src,
  type,
  title,
  description1,
  description2,
  description3,
  className,
  imgCenter,
  link,
  contentClassName,
  spacey,
  hidedsc,
  imgAlignBottomRight, // Add new prop
}: {
  src: string;
  type: string;
  title: string;
  description1: string;
  description2: string;
  description3: string;
  className?: string;
  imgCenter?: boolean;
  link?: string;
  contentClassName?: string;
  spacey?: string;
  hidedsc?: boolean;
  imgAlignBottomRight?: boolean; // Define the new prop
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={`card ${className} md:flex md:justify-between`}>
      <div className="card-content flex flex-col h-full self-start w-[50%] justify-between">
        <div className={`${contentClassName}`}>
          <h1 className="card-title">{type}</h1>
          <h3 className="text-[40px]">{title}</h3>
          <div className={`${spacey}`}>
            <p className="card-description">{description1}</p>
            <p className={`card-description ${hidedsc ? 'hidden' : 'block'}`}>
              {description2}
            </p>
            <p className={`card-description ${hidedsc ? 'hidden' : 'block'}`}>
              {description3}
            </p>
          </div>
        </div>

        <button
          className="p-0 w-fit text-[#1E90AA]"
          onClick={() => link && navigate(link)}
          disabled={contentClassName ? true : false}
        >
          {t('card.detailsButton')}
        </button>
      </div>
      <div
        className={`card-image-container flex ${
          imgAlignBottomRight
            ? 'h-full self-end justify-end' // Align to bottom-right when true
            : imgCenter
              ? 'self-center'
              : 'self-end'
        } md:self-center`}
      >
        <img
          src={src}
          alt={title}
          className={`${imgAlignBottomRight ? 'card-image-fit' : 'card-image'}`}
        />
      </div>
    </div>
  );
};

export default Card;
